import axios from "axios";

const API = axios.create({
  timeout: 10000,
  baseURL: "http://localhost:8081"
});

export default API;
